import React, {Component} from 'react';
import {
  CUSTOMER_INQUIRY_CATEGORIES,
  fetchCustomerInquiryForCurrentUser,
  INQUIRY_STATUSES,
} from '../../../actions/customerInquiry.actions';
import {connect} from 'react-redux';
import moment from 'moment-timezone';
import {Link} from 'react-router-dom';
import {getPublicGameTitle} from '../../../constants/gameType.constants';
import {parseStringToHtmlAndSanitize} from '../../../util/htmlString';
import {Button, ButtonGroup, Table} from '../../Common/PageComponents';

const stateToProps = state => {
  return {
    inquiry: state.customerInquiries.inquiryDetail,
  };
};

class CustomerInquiryDetail extends Component {
  componentDidMount() {
    this.props.dispatch(fetchCustomerInquiryForCurrentUser(this.props.match.params.id));
  }

  _renderAnswer(answer) {
    if (answer) {
      return <p dangerouslySetInnerHTML={parseStringToHtmlAndSanitize(answer.content)}></p>;
    }
    return <p>답변 대기 중 입니다</p>;
  }
  render() {
    let inquiry = this.props.inquiry;
    if (!inquiry) {
      return <div>존재하지 않는 게시물 입니다.</div>;
    }
    return (
      <div>
        <Table theme={'form'}>
          <colgroup>
            <col width="140" />
            <col width="*" />
          </colgroup>
          <tbody>
            <tr>
              <th>아이디</th>
              <td>{inquiry.userName}</td>
            </tr>
            <tr>
              <th>상담일자</th>
              <td>{moment(inquiry.created).format('YYYY-MM-DD')}</td>
            </tr>
            <tr>
              <th>상담현황</th>
              <td>{INQUIRY_STATUSES[inquiry.status]}</td>
            </tr>
            <tr>
              <th>상담내역</th>
              <td>
                {CUSTOMER_INQUIRY_CATEGORIES[inquiry.category]}{' '}
                {inquiry.gameType ? `/ ${getPublicGameTitle(inquiry.gameType)}` : ''}
              </td>
            </tr>
            <tr>
              <th>제목</th>
              <td>{inquiry.title}</td>
            </tr>
            <tr>
              <th>내용</th>
              <td>
                <p dangerouslySetInnerHTML={parseStringToHtmlAndSanitize(inquiry.content)}></p>
              </td>
            </tr>
            <tr>
              <th>첨부파일</th>
              {inquiry.attachedFilePath ? <td>파일 첨부 완료</td> : <td>첨부 파일이 없습니다.</td>}
            </tr>
            <tr>
              <th>답변</th>
              <td>{this._renderAnswer(inquiry.answer)}</td>
            </tr>
          </tbody>
        </Table>
        <ButtonGroup>
          <Link to="/customer/inquiries">
            <Button>확인</Button>
          </Link>
        </ButtonGroup>
      </div>
    );
  }
}

export default connect(stateToProps)(CustomerInquiryDetail);
